import { useEffect } from "react"
import { usePathname } from "@/platform/navigation"
import { useAuth } from "@/lib/auth-context"
import { captureAnalyticsPageView, capturePosPresence, setAnalyticsIdentity } from "@/lib/analytics"

export function AnalyticsIdentity() {
  const { user, loading } = useAuth()
  const pathname = usePathname()

  useEffect(() => {
    if (!loading) setAnalyticsIdentity(user)
  }, [loading, user?.id, user?.tenantId, user?.tenantName])

  useEffect(() => {
    if (!loading && user?.tenantId) captureAnalyticsPageView(pathname)
  }, [loading, user?.tenantId, user?.tenantName, pathname])

  useEffect(() => {
    if (loading || !user?.tenantId || pathname !== "/dashboard/pos/register") return
    capturePosPresence("pos_opened")
    return () => capturePosPresence("pos_closed")
  }, [loading, user?.tenantId, pathname])

  return null
}
